exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ele-import-download[data-v-518339ec]{text-align:center}.ele-import-download .el-icon-document[data-v-518339ec]{font-size:150px;line-height:1.2;color:#67c23a}", ""]);

// exports
